//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'

import Announcements from '@/components/Announcements.vue'
import announcements from '@/graphql/queries/announcements.gql'

import { DATE_FORMAT, BILLING_TERM_MONTH } from '@/lib/constants'
import { isPaidPlan, MAGIC_UNLIMITED_NUMBER } from '@/lib/plans'
import { UserPrefs } from '@/lib/prefs'
import { formatDate } from '@/lib/utils'

export default {
  name: 'TopNav',
  components: {
    announcements: Announcements
  },
  data() {
    const isMobile = window.matchMedia(
      'only screen and (max-width: 768px)'
    ).matches

    let prefs = new UserPrefs()

    return {
      DATE_FORMAT,
      isMobile,
      firstDayOfNextMonth: new moment().add(1, 'months').date(1),
      prefs,
      displayNotifications: false,
      announcements: [],
      isImpersonating:
        process.browser && window.location.search === '?impersonate=1'
    }
  },
  apollo: {
    announcements: {
      query: announcements,
      skip() {
        return !this.isLoggedIn
      }
    }
  },
  computed: {
    hasLoadedProfile() {
      return this.$store.state.hasLoadedProfile
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    profile() {
      return this.$store.state.profile
    },
    finishedInitialLoad() {
      return this.$store.state.finishedInitialLoad
    },
    brandLinkPath() {
      return this.isLoggedIn ? '/dashboard' : '/'
    },
    onLandingPage() {
      return ['/', '/home-redesign', '/use-cases/onlyfans'].includes(
        this.$route.path
      )
    },
    hasUnlimitedPosts() {
      if (!this.profile) {
        return false
      } else {
        return (
          this.profile.account.allowedMonthlyPosts == MAGIC_UNLIMITED_NUMBER
        )
      }
    },
    hasUnlimitedAccounts() {
      if (!this.profile) {
        return false
      } else {
        return (
          this.profile.account.allowedRedditAccounts == MAGIC_UNLIMITED_NUMBER
        )
      }
    },
    shouldShowAnnualPlanUpsell() {
      return (
        this.isLoggedIn &&
        this.profile.account.plan.monthlyPrice > 0.0 &&
        this.profile.account.billingTerm === BILLING_TERM_MONTH &&
        this.prefs.showAnnualUpsellBanner
      )
    },
    shouldShowPostponeUpdate() {
      return this.isLoggedIn && this.$store.state.postponeHasUpdate
    }
  },
  methods: {
    isPaidPlan,
    formatDate,
    async handleLogoutClick() {
      await this.$store.dispatch('logout')
      this.$buefy.toast.open({
        message: 'Successfully logged out',
        type: 'is-info'
      })
      this.$router.push({ path: '/' })
    },
    refreshPage() {
      window.location.reload()
      return false
    },
    hideAnnualPlanUpsellBanner() {
      this.prefs.showAnnualUpsellBanner = false
    }
  }
}
